import { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Der Ursprung der Seite (`https://www.paperball.finance`) — auch dort, wo es
 * kein `window` gibt.
 *
 * Eine Server-Seite (Next.js-Phase 2) rendert zuerst auf dem Server; dort
 * kennt nur die Konfiguration die öffentliche Adresse (`FRONTEND_BASE_URL`),
 * und `OeffentlicheSeite` gibt sie über diesen Kontext weiter — im Browser
 * dieselbe, damit Server- und Browser-HTML übereinstimmen. Die Single-Page-App
 * rendert nur im Browser und setzt keinen Kontext: dort gilt
 * `window.location.origin`.
 */
export const BasisUrlKontext = createContext<string | null>(null);

/** Der Ursprung allein (`https://www.paperball.finance`) — für absolute Adressen auf der Seite. */
export function useUrsprung(): string {
  const basis = useContext(BasisUrlKontext);
  return basis ?? window.location.origin;
}

/** Absolute Adresse der aktuellen Seite, ohne Query und Anker. */
export function useSeitenUrl(): string {
  const ursprung = useUrsprung();
  const { pathname } = useLocation();
  return `${ursprung}${pathname}`;
}
